module.exports = __webpack_public_path__ + "img/product_36.817d5bc.jpg";